import { ElementRef, Injectable } from '@angular/core';

import irisDesignTokens from '@sondermind/iris-design-tokens/design-tokens.json';

@Injectable({
  providedIn: 'root'
})
export class IrisTokenParserService {
  private buildCamelCaseFromArray(array: string[]): string {
    return array.reduce((prev, curr, index) => {
      const accumulator = prev + (index === 0
        ? curr.toLocaleLowerCase()
        : curr.charAt(0).toUpperCase() + curr.slice(1));
      return accumulator;
    }, '');
  }

  /**
   * Translates the design token SCSS name to a key that can be used
   * to retrieve the token value from the token JSON file.
   * Turns '$color-dec-turquoise-03' into 'colorDecTurquoise03'
   * @param sassToken The name of the Iris design token as it would usually be used in SCSS
  */
  parseDesignTokenJsonKey(sassToken: string): string {
    const noDollarSign = sassToken.slice(1);
    const wordArray = noDollarSign.split('-');

    return this.buildCamelCaseFromArray(wordArray);
  }

  /**
   * Sets the color of a style property on the given element to be the color defined by the colorToken
   * The style property should be defined in the scss and named something with the format `--{tokenName}-color`
   * @param colorToken The name of the Iris design token as it would be used in SCSS eg. '$color-dec-turquoise-03'
   * @param tokenName The name of the token which will be used to set the color property of the element
   * @param elementRef
  */
  setColorFromToken(colorToken: string, tokenName: string, elementRef: ElementRef): void {
    if (!elementRef) {
      // eslint-disable-next-line no-console
      console.error(`Given element is not defined. Cannot apply desired color for ${tokenName}.`);
      return;
    }

    if (colorToken.startsWith('$')) {
      const jsonKey = this.parseDesignTokenJsonKey(colorToken);
      const tokenColor = (irisDesignTokens as { [key: string]: string; })[jsonKey];
      if (tokenColor) {
        elementRef.nativeElement.style.setProperty(`--${tokenName}-color`, tokenColor);
      } else {
        // eslint-disable-next-line no-console
        console.error(`Iris token parser error for ${tokenName}: ${colorToken} is not a recognized Iris design token.`);
      }
    }
  }
}
